<template>
  <div class="mx-auto mt-12 max-w-screen-md px-6 font-light md:px-8">
    <h3>About Aussie Broadband Limited</h3>
    <p>
      Aussie Broadband Group is a fast-growing telecommunications services
      provider - comprising of the Aussie Broadband and Symbio businesses.
    </p>
    <p>
      Listed on the Australian Stock Exchange (ASX: ABB), the Group collectively
      supplies more than 1 million services, operates two Tier 1 voice providers
      in Australia and owns fibre infrastructure.
    </p>
    <p>
      The fifth largest provider of broadband services in Australia with
      continuing growth in the residential segment, the Group provides a broad
      suite of solutions through its data, voice, and managed solutions to
      business, enterprise and government customers. Aussie Broadband Group also
      provides wholesale services to other telecommunications companies and
      managed service providers.
    </p>
    <p>
      For further information please visit:
      <NuxtLink to="https://www.aussiebroadband.com.au"
        >www.aussiebroadband.com.au</NuxtLink
      >
    </p>
  </div>
</template>
